<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper" >
            <!-- Content Header (Page header) -->
            <section class="content-header">
          
            </section>
            <!-- Main content -->
            <section class="content" v-if="this.userLoaded" >
                <div class="box">
                    <div class="box-body" style="min-height:400px; background: #F0F0ED; border:color: white; border-width:5%">
             
                        <div class="movie-card">
                            <div class="container-movie">
                              <!--div  v-if="!this.mobileAndTabletCheck">
                                 <div class="hero">
                                    <div class="details-profile">
                        <div class ="row">
                                        <div class = "col-md-8 col-sm-4">
                                          <div>
                                          <a href="#"><img  src="static/img/FENDRLOGO.png" alt="cover" class="cover-profile-mobile" style = "width: 100%;  margin-top: 200px"/></a>
                                        </div>
                                        </div>
                                        <div class="col-md-8 col-sm-8">
                                        <div class="title1" ><h1 style="background:black; padding-top:-5% ;display: inline-block; text-align: center; padding:0em 0.2em 0em 0.2em;"><strong>{{this.user.firstName}} {{this.user.lastName}}</strong></h1></div>
                                        </div>
                                      </div>    
                                    </div>
                                 </div>                          </div>
                              <div  v-else>
                                
                                <div class="hero">
                                    <div class="details-profile">
                                      <div class ="row">
                                        <div class = "col-md-8">
                                          <a href="#"><img  src="static/img/FENDRLOGO.png" alt="cover" class="cover-profile-mobile" style = "width: 100%;  margin-top: 200px"/></a>
                                        </div>
                                        <div class="col-md-8">
                                        <div class="title1" ><h1 style="background:black; padding-top:-5% ;display: inline-block; text-align: center; padding:0em 0.2em 0em 0.2em;"><strong>{{this.user.firstName}} {{this.user.lastName}}</strong></h1></div>
                                        </div>
                                      </div>
                                    </div>
                               
                                    < end details >
                                </div>
                              </div-->
                              <div v-if="!this.mobileAndTabletCheck()">
                                <div class="hero">
                                    <div class="details-profile">
                               <div class ="row" style="margin-top: 9%">
                                        <div class="col-md-4 col-xs-4">
                                           <div class="float-right" >
                                          <a href="#"><img alt="cover"   src="static/img/REKFIXLOGOSMALL.png"  style = "background:black;  width: 75px; border-radius: 50%;
    border: 4px solid #FFF;"></a>
                                           </div>
                                        </div>
                                        <div class="col-md-8 col-xs-8">
                                        <div class="float-left" ><h1 style="font-size: 3vw;background:black; color:white; padding-top:-5% ;display: inline-block; text-align: center; padding:0em 0.2em 0em 0.2em;"><strong>{{this.user.firstName}} {{this.user.lastName}}</strong></h1></div>
                                        </div>
                                      </div>    
                                    </div>
                                 </div> 
                              </div>
                                              <div v-else>
                                <div class="hero">
                                    <div class="details-profile">
                               <div class ="row" style="margin-left: 3%; margin-top: 39%">
                                        <div class="col-md-4 col-xs-4">
                                           <div class="float-right" >
                                          <a href="#"><img alt="cover"   src="static/img/REKFIXLOGOLARGE.png"  style = "background:black;  width: 75px; border-radius: 50%;
    border: 4px solid #FFF;"></a>
                                           </div>
                                        </div>
                                        <div class="col-md-8 col-xs-8">
                                        <div class="float-left" ><h1 style="font-size: 5vw;background:black; color:white; padding-top:-5% ;display: inline-block; text-align: center; padding:0em 0.2em 0em 0.2em;"><strong>{{this.user.firstName}} {{this.user.lastName}}</strong></h1></div>
                                        </div>
                                      </div>    
                                    </div>
                                 </div> 
                              </div>
                                <!-- end hero -->
                                <div class="description-profile ">
                                
                                    <!-- end column1 -->
                                   <div  class="column2" style="margin-left: 5%;">
                                        <div class="row">
                                              <div class="col-xs-12 col-sm-4 emphasis">
                                                <h2 style="color:rgba(0, 0, 0, 0.9);">
                                        <strong>Update Profile</strong>
                                    </h2>
                                                <p> <small>Update User Profile</small> </p>
                                                
                                                <button class="btn btn-info " v-on:click="handleUpdate"> <span class="fa fa-user"></span>&nbsp;&nbsp;Update Profile</button>
                                            </div>
                                            <div class="col-xs-12 col-sm-4 emphasis">
                                                <h2>
                                        <strong style="color:rgba(0, 0, 0, 0.9);">Auto Insurance</strong>
                                    </h2>
                                                <p> <small>Policy Information</small> </p>
                                                <a href="#/policies/PolicyList">
                                                <button  class="btn btn-success "> <span class="fa fa-eye"></span>&nbsp;&nbsp;View Insurance Policies</button>
                                                 </a>
                                            </div>
                                          
                                          
                                        </div>
                                    </div>
                                    <!-- end column2 -->
                                        <div class="column1 text-center" style="margin-left: 0%; "><div class="col-xs-12 col-sm-12 profile-name">
                               
                                <hr>                                <h2 style=" color:rgba(0, 0, 0, 0.9);"><strong>User Information</strong></h2>
<hr>
                                <dl class="dl-horizontal-profile"> 
                                     <dt>First Name</dt><dd>{{this.user.firstName}}</dd>
                                     <dt>Last Name</dt>
                                    <dd>{{this.user.lastName}}</dd> <dt>Email</dt>
                                    <dd>{{this.user.email}}</dd> <dt>Phone</dt>
                                    <dd>{{this.user.phone}}</dd> <dt>Zipcode</dt>
                                    <dd>{{this.user.zipcode}}</dd> <dt>City</dt>
                                    <dd>{{this.user.city}}</dd> <dt>State</dt>
                                     <dd>{{this.user.state}}</dd>
                                </dl>
                            </div> </div>
                                </div>
                                <!-- end description -->
                            </div>
                            <!-- end container -->
                        </div>
                        <!-- end movie-card -->
                        
                    </div>
                </div>
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
  const commonDB = require('../services/database/common')
const db = require('../services/database/database')

        var to = require('await-to-js').default
        const cliStorage = require('../services/libraries/clientStoragelib')
const cliStorNames = cliStorage.clientStorageNames
const Auth = require('../services/Authentication/auth')
const cliStoreOps = require('../common/clientStorageOperations')
const models = require('../services/database/models')

  export default {
    name: 'Profile',
    async beforeMount(){
        const userToken = this.$cookie.get(cliStorNames.USER_TOKEN.name)
        if (!userToken){
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()

            this.$router.push('/login')
        }
        this.userToken = userToken
        let userErr, userRes;
          [userErr, userRes] = await to(Auth.getUser({ UID: userToken }));
          if (userErr) {
            console.log("getting user userErr", userErr.response);
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')
          } else if (userRes) {
              console.log("userRes",userRes)
              const userId = this.$route.params.userId
              this.userId = userId
              
               const jwt_decode = require('jwt-decode');
      const decoded_header = jwt_decode(this.userToken)
      this.userAccountId = decoded_header.user_id
      let userDbErr, userDbRes;
              [userDbErr, userDbRes] = await to(commonDB.getUserFromDB(this.userToken, this.userAccountId))
              if (userDbErr){
                    console.log("ERROR", dbErr)
                    this.$confirm("Unable to Load Profile Contents. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
              }
              try{
                console.log("user db res", userDbRes)
                console.log("Here0")

                let pulledUserId = userDbRes.data.fields.userId.stringValue
                console.log("Here1")

                if (pulledUserId !== this.userId){
                     this.$confirm("Unable to retrieve User Profile. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
}
console.log("Here")
                this.user.firstName = userDbRes.data.fields.firstName.stringValue
                this.user.lastName = userDbRes.data.fields.lastName.stringValue
                this.user.email = userDbRes.data.fields.email.stringValue
                this.user.phone = userDbRes.data.fields.phone.stringValue
                this.user.zipcode = userDbRes.data.fields.zipcode.stringValue
                this.user.city = userDbRes.data.fields.city.stringValue
                this.user.state = userDbRes.data.fields.state.stringValue
                this.user.userCreationDate = userDbRes.data.fields.userCreationDate.stringValue
                this.userLoaded = true
console.log("Here e")

              
          }
           catch(err){
                    console.error(err)
                     this.$confirm("Unable to retrieve User Profile. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
           }
          }
    },
    data (){
      return {
         user: {},
         userLoaded: false,
         userAccountId: "",
         userToken: "",
      }
    },
    methods: {
      mobileAndTabletCheck : function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  console.log("mobile", check)
  return check;
},
      formatTooltip (val) {
        return val / 100
      }, 
      handleUpdate(){
                    this.userLoaded = false

          this.$router.push({name: 'updateUserProfile', params: {user:this.user }})
      },
      updateModelDropdown(){
          this.modelValue = ''
          this.yearValue=  ''
          this.modelOptions =  this.makeOptions.filter(e => e.brand === this.makeValue)[0].models;//unsafe
          console.log("changed", this.modelOptions)
      },
    
    }
  }
</script>


// WEBPACK FOOTER //
// userProfile.vue?7b318350